module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDMgTDEwMCAwIEwxMDAgOTcgTDAgMTAwIFoiIGZpbGw9IiNEQURBREIiIC8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/MauerBack/rhombus-phone.svg
// module id = 433
// module chunks = 35783957827783